import infoGreen from 'assets/images/account-page/info-green.svg';
import leadAutomatorAnnualIcon from 'assets/images/plan-lead-annual.svg';
import marketingAnnualIcon from 'assets/images/plan-marketing-annual.svg';
import savesExportsIcon from 'assets/images/plan-saves-exports.svg';
import skipTracingIcon from 'assets/images/plan-skip-tracing.svg';
import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import { getBrandName } from 'utils/brand';
import { useDispatch, useSelector } from "react-redux";
import { selectPlanDetails, updateSelectedChooseTierTooltip } from "../../../../data/user";
import css from "../style.scss";
import SVG from 'components/base/SVG';

import callSettingIcon from 'assets/images/plan-description/plan-call-setting.svg';
import planPostcardIcon from 'assets/images/plan-description/plan-postcard.svg';
import planMobileIcon from 'assets/images/plan-description/plan-mobile.svg';

const AnnualEssentialsIncludes = () => {
    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();
    const containerRef = useRef(null);

    const handleTooltipToggle = (tooltipId) => {
        const tooltipComponentId = `annualEssentials-${tooltipId}`;
        dispatch(updateSelectedChooseTierTooltip(tooltipComponentId));
    };

    useEffect(() => {
        return () => {
            dispatch(updateSelectedChooseTierTooltip(""));
        };
    }, []);
    return (
        <div className={css.clsInfoPopup} ref={containerRef}>
            <li>
                <img src={callSettingIcon} className={css.clsIncludesIcon} alt="Click-to-Dial Calling Bonus" />
                <p>
                    <strong>Click-to-Dial Calling Bonus:</strong> 2 Months Free
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('calling')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'annualEssentials-calling',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Click-to-Dial Calling Bonus <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>With {getBrandName()}'s Click-to-Dial, you can instantly call property owners directly inside the platform using a built-in softphone. Simply click a phone number to start a live call, supported by ranked contact data and AI-guided prompts—no exports or extra tools required. Just faster, more confident outreach with your skip-traced leads.</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={leadAutomatorAnnualIcon} className={css.clsIncludesIcon} alt="Lead Automator Bonus" />
                <p>
                    <strong>Lead Automator Bonus: </strong>
                    2 Months <br/> Free
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('lead')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'annualEssentials-lead',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Lead Automator Bonus <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Automatically track and get updates on 50,000 properties with custom filters. <b>Lead Automator</b> updates and refines your real estate lead lists based on custom filters, ensuring you always have the freshest opportunities at your fingertips. It's like having a personal assistant for your pipeline!</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={planMobileIcon} className={css.clsIncludesIcon} alt="Skip Tracing Bonus" />
                <p>
                    <strong>Skip Tracing Bonus:</strong> 2 Months Free Worth $3,000
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('skipping')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'annualEssentials-skipping',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Skip Tracing Bonus <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Need more contact details? Free Skip Tracing is available to the main account holder, via our third-party vendor, and helps you uncover phone numbers and emails for your leads, giving you the tools to connect directly and efficiently. Say goodbye to dead ends and hello to new opportunities.</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <SVG icon='chartsidebarPlan' className={css.clsIncludesIcon} width={22} height={22} />
                <p><strong>Dialer Campaigns Bonus:</strong> 2 Months Free</p>
            </li>
            <li>
                <img src={planPostcardIcon} className={css.clsIncludesIcon} alt="Save on Postcards" />
                <p><strong>Save on Postcards,</strong> prices as low as 48¢</p>
            </li>
            <li>
                <img src={marketingAnnualIcon} className={css.clsIncludesIcon} alt="Marketing Credit Bonus" />
                <p>
                    <strong>Marketing Credit Bonus: </strong>
                    $100
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('marketing')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'annualEssentials-marketing',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Marketing Credit Bonus <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>This one time <b>marketing credit</b> can help simplify your outreach with credits you can use for skip tracing, emails, or postcards. It’s a flexible way to connect with leads and keep your marketing efforts moving forward.</p>
                        </div>
                    </span>
                </p>
            </li>
        </div>
    )
}

export default AnnualEssentialsIncludes;
